import StringMask from 'string-mask';
import { MASK, PHONE_MASK_REGEX } from '../utilities/constants';
import unmaskValue from '../components/utilities/unmaskValue';

export const maskPhone = str => {
  const unmaskedValue = unmaskValue(str, PHONE_MASK_REGEX);
  const formatted = StringMask.process(unmaskedValue, MASK);
  return formatted.result;
};
